// CursoCard.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Button, CardActions, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const CursoCard = ({ curso }) => {
  if (!curso || !curso.id) {
    return null;
  }

  return (
    <Card elevation={2} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" component="div" gutterBottom>
          {curso.nome || 'Nome não disponível'}
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Instituição: {curso.campanha?.instituicao?.nome || 'N/A'}
        </Typography>
        <Typography variant="body2">
          {curso.descricao || 'Descrição não disponível.'}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-start', p: 2 }}>
        <Button 
          component={Link} 
          to={`/cursos/${curso.id}`} 
          variant="contained" 
          color="primary" 
          size="small"
        >
          Ver Detalhes
        </Button>
      </CardActions>
    </Card>
  );
};

CursoCard.propTypes = {
  curso: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    nome: PropTypes.string,
    descricao: PropTypes.string,
    campanha: PropTypes.shape({
      instituicao: PropTypes.shape({
        nome: PropTypes.string,
      }),
    }),
  }),
};

CursoCard.defaultProps = {
  curso: null,
};

export default CursoCard;